export const STATUS_START = 'start';
export const STATUS_LOADING = 'loading';
export const STATUS_FAILURE = 'failure';
export const STATUS_SUCCESS = 'success';

export type Status = 'start' | 'loading' | 'failure' | 'success';
